import { jsPDF } from "jspdf";
import { ZONES, VEILLE, VEILLE_UPDATED } from "@/data/veille";

const NAVY = [0, 22, 95];
const NIGHT = [0, 12, 61];
const GOLD = [212, 160, 23];
const GREY = [74, 74, 74];
const HEADER_MSG = "Votre partenaire stratégique ancré en France et en Outre-mer, au service de la diaspora et présent à vos côtés en Afrique, notamment au Bénin et en Côte d'Ivoire.";

function loadLogo() {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = img.width; c.height = img.height;
      c.getContext("2d").drawImage(img, 0, 0);
      resolve({ data: c.toDataURL("image/png"), ratio: img.width / img.height });
    };
    img.onerror = () => resolve(null);
    img.src = "/logo.png";
  });
}

function footer(doc) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  doc.setFillColor(...NIGHT); doc.rect(0, H - 12, W, 12, "F");
  doc.setTextColor(247, 243, 234); doc.setFontSize(7.5); doc.setFont("helvetica", "normal");
  doc.text("Bridge Partners · 102 Av. des Champs-Élysées, 75008 Paris · Cotonou · Abidjan · contact@bridgepartners.fr", W / 2, H - 4.5, { align: "center" });
}

function header(doc, logo, subtitle) {
  const W = doc.internal.pageSize.getWidth();
  doc.setFillColor(...NAVY); doc.rect(0, 0, W, 28, "F");
  if (logo) { const h = 13, w = h * logo.ratio; try { doc.addImage(logo.data, "PNG", 14, 7.5, w, h); } catch (e) {} }
  doc.setTextColor(...GOLD); doc.setFont("helvetica", "bold"); doc.setFontSize(9);
  doc.text(subtitle, W - 14, 16, { align: "right" });
}

async function coverPage(doc, logo) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  doc.setFillColor(...NIGHT); doc.rect(0, 0, W, H, "F");
  if (logo) { const h = 26, w = h * logo.ratio; try { doc.addImage(logo.data, "PNG", (W - w) / 2, 45, w, h); } catch (e) {} }
  doc.setTextColor(255, 255, 255); doc.setFont("helvetica", "bold"); doc.setFontSize(24);
  doc.text("Rapport de Veille Stratégique", W / 2, 95, { align: "center" });
  doc.setTextColor(...GOLD); doc.setFontSize(11); doc.setFont("helvetica", "normal");
  doc.text(`France & Outre-mer · Bénin · Côte d'Ivoire — ${VEILLE_UPDATED}`, W / 2, 105, { align: "center" });
  doc.setTextColor(220, 220, 230); doc.setFontSize(10);
  doc.text(doc.splitTextToSize(HEADER_MSG, W - 60), W / 2, 122, { align: "center" });
  // market highlights
  let y = 150;
  doc.setTextColor(...GOLD); doc.setFont("helvetica", "bold"); doc.setFontSize(11);
  doc.text(VEILLE.market.title, W / 2, y, { align: "center" });
  doc.setTextColor(230, 230, 235); doc.setFont("helvetica", "normal"); doc.setFontSize(9.5);
  y += 8;
  VEILLE.market.points.forEach((p) => { doc.text(doc.splitTextToSize("• " + p, W - 60), W / 2, y, { align: "center" }); y += 10; });
  footer(doc);
}

function zonePage(doc, logo, zone) {
  doc.addPage();
  const W = doc.internal.pageSize.getWidth();
  header(doc, logo, "Rapport de Veille Stratégique");
  let y = 42;
  doc.setTextColor(...NAVY); doc.setFont("helvetica", "bold"); doc.setFontSize(22);
  doc.text(zone.name, 14, y);
  y += 10;
  zone.categories.forEach((cat) => {
    if (y > 250) { doc.addPage(); header(doc, logo, "Rapport de Veille Stratégique"); y = 42; }
    doc.setDrawColor(...GOLD); doc.setLineWidth(0.7); doc.line(14, y, W - 14, y); y += 6;
    doc.setTextColor(...NAVY); doc.setFont("helvetica", "bold"); doc.setFontSize(13);
    doc.text(cat.title, 14, y); y += 6;
    doc.setTextColor(...GOLD); doc.setFont("helvetica", "italic"); doc.setFontSize(9.5);
    doc.text(doc.splitTextToSize(cat.highlight, W - 28), 14, y); y += 7;
    doc.setTextColor(...GREY); doc.setFont("helvetica", "normal"); doc.setFontSize(9.5);
    cat.points.forEach((p) => {
      const lines = doc.splitTextToSize("•  " + p, W - 30);
      doc.text(lines, 16, y); y += lines.length * 4.8 + 1.5;
    });
    y += 5;
  });
  footer(doc);
}

async function chartsPage(doc, logo) {
  const el = document.querySelector('[data-testid="strategy-dashboard"]');
  if (!el) return;
  try {
    const html2canvas = (await import("html2canvas")).default;
    const canvas = await html2canvas(el, { scale: 1.4, backgroundColor: "#F7F3EA", useCORS: true, logging: false });
    doc.addPage();
    header(doc, logo, "Tableau de bord");
    const W = doc.internal.pageSize.getWidth();
    doc.setTextColor(...NAVY); doc.setFont("helvetica", "bold"); doc.setFontSize(16);
    doc.text("Tableau de bord stratégique", 14, 42);
    const imgW = W - 28;
    const imgH = (canvas.height / canvas.width) * imgW;
    const maxH = doc.internal.pageSize.getHeight() - 60;
    const finalH = Math.min(imgH, maxH);
    const finalW = (canvas.width / canvas.height) * finalH;
    doc.addImage(canvas.toDataURL("image/png"), "PNG", 14, 48, Math.min(imgW, finalW), Math.min(imgH, finalH));
    footer(doc);
  } catch (e) { /* charts capture optional */ }
}

export async function exportVeillePdf() {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const logo = await loadLogo();
  await coverPage(doc, logo);
  await chartsPage(doc, logo);
  ZONES.forEach((z) => zonePage(doc, logo, z));
  doc.save("Bridge-Partners-Rapport-Veille.pdf");
}
